/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/sortableList/sortableListHeadSelector/sortableListHeadSelectorView",
], function (Marionette, Messenger, SortableListHeadSelectorView) {
  var SortableListHeadSelectorController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "sortableListHeadSelector";
      this.region = options.region;
      this.headers = options.headers;
      this.namespace = options.namespace;
      if (this.namespace) {
        this.namespacePrefix = this.namespace + ":";
      } else {
        this.namespacePrefix = "";
      }
      this._setUpVents();
    },
    show: function () {
      this.view = new SortableListHeadSelectorView.sortableListHeadSelectorView({
        collection: this.headers,
      });

      this.view.on(
        "itemview:toggle:column",
        function (itemView, selected) {
          console.log("header: " + itemView.model.get("headerName") + " is " + selected);
          //set the visibility of the header
          itemView.model.set("hidden", !selected);
          //trigger the header and body to rerender
          Messenger.vent.trigger(this.namespacePrefix + "headers:changed");
        },
        this,
      );
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.reqres.setHandler(
        this.namespace + ":all:visible:columns",
        function () {
          var visible = [];
          for (var i = 0; i < this.headers.models.length; i++) {
            if (this.headers.models[i].get("modelAttribute") !== undefined) {
              //It does map to a model attribute
              if (this.headers.models[i].get("hidden") === false) {
                //It is not hidden
                visible.push(this.headers.models[i]);
              }
            }
          }
          return visible;
        },
        this,
      );
    },
  });

  return SortableListHeadSelectorController;
});
